import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { useRouteParams } from '../hooks/useRouteParams';
import { AccountStatus } from '../AccountOpening.meta';

interface SubmitDraftParams {
  clientId: string;
  id: string;
  isFromAutomatedAccounts: boolean;
}

interface SubmitDraftResponse {
  accountOpeningStatus: AccountStatus;
}

const submitDraft = ({
  clientId,
  id,
  isFromAutomatedAccounts,
}: SubmitDraftParams): Promise<SubmitDraftResponse> => {
  return authFetch('/Consumer/ManagedAccounts/SubmitAccountOpeningRequest', {
    method: 'POST',
    ...httpBodyOptions({ clientId, id, isFromAutomatedAccounts }),
  });
};

export const useSubmitDraftMutation = () => {
  const { clientId, draftId, isFromWorkflow } = useRouteParams();

  return useMutation(() =>
    submitDraft({ clientId, id: draftId, isFromAutomatedAccounts: isFromWorkflow }),
  );
};
